<template>
  <v-menu v-model="menuOpen" location="bottom end" offset="8" class="cursor-pointer">
    <template #activator="{ props }">
      <v-btn v-bind="props" variant="flat" rounded="lg"
        class="nav-icon cursor-pointer mr-3 user-menu-badge px-1 pr-3 text-none">
        <v-avatar size="28" color="accent-color" rounded="lg">
          <span class="text-white font-weight-bold" style="font-size: 0.8rem; line-height: 1;">
            {{ initials }}
          </span>
        </v-avatar>
        <span class="ml-3 text-brand-color font-weight-medium">{{ firstName }}</span>
        <v-icon size="18" class="ml-2 text-medium-emphasis">
          {{ menuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </v-btn>
    </template>
    <v-card min-width="240" rounded="lg" elevation="1" class="py-2">
      <!-- User Info -->
      <div class="d-flex align-center px-4 py-3 ga-3">
        <v-avatar size="40" color="brand-color" rounded="lg" variant="tonal">
          <span class="text-brand-color font-weight-medium">{{ initials }}</span>
        </v-avatar>
        <div>
          <div class="text-body-large font-weight-semibold text-high-emphasis">{{ userName }}</div>
          <div class="text-body-small text-medium-emphasis">{{ userEmail }}</div>
        </div>
      </div>

      <v-divider />

      <!-- Menu Items -->
      <div class="pa-2">
        <router-link :to="{ name: 'user.profile' }" class="text-decoration-none">
          <div class="menu-item d-flex align-center ga-2 px-3 py-3 rounded-lg cursor-pointer">
            <v-icon size="18" color="brand-color" class="opacity-70">mdi-account-cog</v-icon>
            <span class="text-body-medium text-high-emphasis">My Profile</span>
          </div>
        </router-link>
        <router-link :to="{ name: 'help.index' }" class="text-decoration-none">
          <div class="menu-item d-flex align-center ga-2 px-3 py-3 rounded-lg cursor-pointer">
            <v-icon size="18" color="brand-color" class="opacity-70">mdi-help-circle</v-icon>
            <span class="text-body-medium text-high-emphasis">Help & Support</span>
          </div>
        </router-link>
      </div>

      <v-divider />

      <div class="pa-2">
        <div @click="handleLogout"
          class="menu-item menu-item--logout d-flex align-center ga-2 px-3 py-3 rounded-lg cursor-pointer">
          <v-icon size="20" color="danger-color">mdi-logout</v-icon>
          <span class="text-body-medium text-danger-color">Sign out</span>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import authMixin from '@/mixins/auth'
import * as actionTypes from '@/store/action-types'

export default {
  name: 'UserMenu',
  mixins: [authMixin],
  props: ['userData'],
  data() {
    return {
      menuOpen: false
    }
  },
  computed: {
    userName() {
      return this.userData?.name
    },
    firstName() {
      return this.userData?.name?.split(' ')?.[0] || 'User'
    },
    userEmail() {
      return this.userData?.email
    },
    initials() {
      return (this.userData?.name || 'User')
        .split(' ')
        .map(n => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    }
  },
  methods: {
    handleLogout: function () {
      this.$store.dispatch(actionTypes.LOGOUT_USER).then((result) => {
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>

<style scoped>
.user-menu-trigger {
  transition: background-color 0.2s ease;
}

.user-menu-trigger:hover {
  background-color: rgba(var(--brand-color-rgb), 0.05);
}

.user-menu-badge {
  border: 1px solid rgba(var(--brand-color-rgb), 0.5) !important;
  color: rgba(var(--brand-color-rgb), 0.9) !important;
}

.user-menu-badge:hover {
  background-color: rgba(var(--brand-color-rgb), 0.08) !important;
  border-color: rgba(var(--brand-color-rgb), 0.5) !important;
}


.menu-item {
  transition: background-color 0.2s ease;
}

.menu-item:hover {
  background: rgba(var(--brand-color-rgb), 0.08);
}

.menu-item--logout:hover {
  background: rgba(var(--v-theme-error), 0.1);
}
</style>
